import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { useSettings } from "@/context/SettingsContext";
import { MessageCircle } from "lucide-react";

export default function Footer() {
  const { openWhatsapp } = useSettings();
  return (
    <footer className="border-t border-chessup-border bg-chessup-deep" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid gap-8 md:grid-cols-3">
        <div>
          <Logo size={44} />
          <p className="mt-4 text-sm text-chessup-subtext max-w-xs">
            Você não assiste xadrez. Você joga a aula. A jornada completa para transformar seu xadrez.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div className="space-y-2">
            <a href="/#cursos" className="block text-chessup-subtext hover:text-chessup-turq">Cursos</a>
            <a href="/#metodologia" className="block text-chessup-subtext hover:text-chessup-turq">Metodologia</a>
            <a href="/#assinatura" className="block text-chessup-subtext hover:text-chessup-turq">Assinatura</a>
          </div>
          <div className="space-y-2">
            <Link to="/termos" className="block text-chessup-subtext hover:text-chessup-turq">Termos</Link>
            <Link to="/privacidade" className="block text-chessup-subtext hover:text-chessup-turq">Privacidade</Link>
            <a href="/#faq" className="block text-chessup-subtext hover:text-chessup-turq">Contato</a>
          </div>
        </div>
        <div>
          <button onClick={() => openWhatsapp("homepage")} className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-3 text-sm font-semibold text-white hover:opacity-90" data-testid="footer-whatsapp">
            <MessageCircle className="h-4 w-4" fill="currentColor" /> Falar com a ChessUp
          </button>
        </div>
      </div>
      <div className="border-t border-chessup-border/60 py-5 text-center text-xs text-chessup-subtext">
        © {new Date().getFullYear()} ChessUp Academy. Todos os direitos reservados.
      </div>
    </footer>
  );
}
